/**
 * Names for the wizard's steps, derived from the answers given so far.
 *
 * The step count (and which screen sits at which index) depends on the data type, period,
 * indicator and time-mapping choices, mirroring `DataStepsForm` / `DataStepsFive` — keep them in
 * sync. Until a choice is made the list stops at the last step that is already known.
 */
const getWizardStepLabels = (form: any): string[] => {
  const labels = ['Name', 'Data type'];
  const { dataType, dataPeriod, importIndicatorType, multipleIndicatorsType, selectedTimePeriod } =
    form ?? {};

  if (dataType === '1') return [...labels, 'Properties', 'Sync options'];
  if (dataType !== '2' && dataType !== '3') return labels;

  labels.push('Time period');
  if (dataPeriod === '2') labels.push('Time mapping');
  if (!dataPeriod) return labels;

  labels.push('Indicators');
  if (!importIndicatorType) return labels;

  if (importIndicatorType === '1') return [...labels, 'Dimension columns', 'Sync options'];

  labels.push('Indicator mapping');
  if (!multipleIndicatorsType) return labels;

  // Rows-based indicators need one more step to pick the value column. With multiple periods
  // that extra step only applies when the time periods are also in rows.
  const needsValueColumn =
    multipleIndicatorsType === 'row' && (dataPeriod === '1' || selectedTimePeriod === 'row');
  if (needsValueColumn) labels.push('Value column');

  return [...labels, 'Dimension columns', 'Sync options'];
};

export default getWizardStepLabels;
